<template>
    <div>
        <div class="service">
            <sui-button @click="eraseDevice">Erase device</sui-button>
            <sui-button @click="reloadDevice">Reload device</sui-button>
            
        </div>
        <grid-layout
            :layout.sync="layout"
            :col-num="gridConfig.colNum"
            :row-height="50"
            :is-draggable="false"
            :is-resizable="false"
            :is-mirrored="false"
            :vertical-compact="false"
            :margin="[0, 0]"
            :use-css-transforms="true"
            :key="JSON.stringify(gridConfig)"
            :autoSize="true">
            <grid-item v-for="item in layout"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                :key="item.i">
                <div class="inner-item">
                
                    <component :is="getComponent(items[item.i].type)" :parameters="items[item.i]" :key="item.i" @updateValue="onUpdateValue($event, item.i);" @postDeviceData="onPostDeviceData" />
                    </div>
                    
            </grid-item>
        </grid-layout>
  </div>
</template>

<script>
// @ is an alias to /src
import VueGridLayout from 'vue-grid-layout';


import ModuleText from '@/components/Module/Text';
import ModuleInput from '@/components/Module/Input';
import ModuleSelect from '@/components/Module/Select';
import ModuleButton from '@/components/Module/Button';
import ModuleMqtt from '@/components/Module/Mqtt';
import api from '@/Api';
import { mapState } from 'vuex'
const awsIot = require('aws-iot-device-sdk');


export default {
    name: 'home',
    data () {
        return {
            device: null,
            awsCredentials: null
        }
    },
  computed: {
    ...mapState({
        gridConfig: state => state.app.gridConfig,
        layout: state => state.app.layout,
        items: state => state.app.items,
        loaded: state => state.loaded
    }),
    ...mapState([
        'deviceId',
        'deviceSecret',
    ])
  },
  methods: {
        getComponent(component) {
            return 'Module' + component;
        },
        onPostDeviceData($event)    
        {
            var enabledTypes = ['Input', 'Select'];
            
            var data = {
                timestamp: (new Date()).getTime()
            };

            Object.keys(this.items).forEach(key => {
                let item = this.items[key];
                if (enabledTypes.indexOf(item.type)>-1)
                {
                    data[item.name] = item.value;
                }
            })
            
            api.send(data);

            console.log(data);
        },
        onUpdateValue(e, item)
        {
            this.$store.commit('updateItemValue', {'key': item, 'value': e});
        },
        reloadDevice()
        {
            api.load(this.deviceId, this.deviceSecret).then(res => {
                
                this.$store.commit('setApp', res.data.parameters);    
                if (res.data.mqtt)
                {
                    this.$store.commit('setMqtt', res.data.mqtt);
                    this.initMqtt();
                }
            })
        },
        eraseDevice()
        {
            this.$store.commit('setDeviceSecret', null);
            this.$router.push({'name': 'auth'});
        },
        async getCredentials() {
            if (!this.$store.getters.hasValidAwsCredentials)
            {
                console.log('invalid credentials, reload ...');
                this.$store.commit('setAwsCredentials', await api.loadCredentials(this.deviceId, this.deviceSecret).then(res => res.data));
            }
            return this.$store.state.awsCredentials;
        },
        updateMqtt(deviceId, payload) {
            var data = JSON.parse(payload.toString());
            var device = deviceId.split('/');
            
            var itemKeys = this.$store.getters.findItemsByDeviceId(device[1]);
            
            Object.keys(itemKeys).forEach(key => {
                let fieldName = itemKeys[key];
                if (typeof data[fieldName] !== 'undefined')
                {
                    this.$store.commit('updateItemValue', {'key': key, 'value': data[fieldName]});
                }
                else
                {
                    console.log('Field name ' + fieldName + ' was nout found in item ' + key);
                }

            })
        },
        async initMqtt()
        {
            if (!this.device && this.$store.state.mqtt)
            {
                var tokens = this.$store.state.mqtt.token.split(',');

                // get credentials
                let credentials = await this.getCredentials();
                
                this.device = awsIot.device({
                    region: 'eu-central-1',
                    host: 'a3ue0wgk8jf0hr-ats.iot.eu-central-1.amazonaws.com',
                    clientId: tokens[0],
                    protocol: 'wss',
                    maximumReconnectTimeMs: 8000,
                    debug: false,
                    accessKeyId: credentials.AccessKeyId,
                    secretKey: credentials.SecretAccessKey,
                    sessionToken: credentials.SessionToken
                });

                //this.device.updateAppMqtt = this.updateMqtt;

                this.device
                .on('connect', function() {
                    console.log('mqtt connected');
                    var subTokens = tokens.splice(1);
                    for (let i in subTokens)
                    {
                        console.log('subscribe v/' + subTokens[i]);
                        this.subscribe('v/' + subTokens[i]);    
                        
                    }
                });

                this.device.on('error', (error) => console.log({'error': error.type}));

                this.device.on('message', this.updateMqtt);
            }
        }

  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    ModuleText: ModuleText,
    ModuleInput: ModuleInput,
    ModuleSelect: ModuleSelect,
    ModuleButton: ModuleButton,
    ModuleMqtt: ModuleMqtt,
  },
  mounted: function() {
      this.initMqtt();
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .service { width: 100%; padding: 5px; background: lemonchiffon; border-bottom: 1px solid grey; text-align: center;}
</style>
